import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Drawer, DrawerContent, DrawerTitleHeader } from "@/components/ui/drawer";
import clsx from "clsx";
import { useState } from "react";
import HistoryTab from "./history-statistic/HistoryTab";
import StatisticTab from "./history-statistic/StatisticTab";
import { useTranslations } from "next-intl";

const HistoryStatistic = NiceModal.create(() => {
  const t_gullak = useTranslations('gullak');
  const TABS = [
    { id: "history", label: t_gullak('obtain'), operate: "1" },
    { id: "statistic", label: t_gullak('claim'), operate: "2" },
  ];
  const modal = useModal();
  const [activeTab, setActiveTab] = useState(TABS[0].id);

  const handleClose = () => {
    modal.hide();
  };

  const onTabChange = (value: string) => {
    setActiveTab(value);
  };

  return (
    <Drawer open={modal.visible} onOpenChange={handleClose}>
      <DrawerContent className="bg-[#181D29] h-[72vh] flex">
        <DrawerTitleHeader title={t_gullak('gullakHistory')} showClose />
        <div className="h-full overflow-hidden px-4 flex flex-col">
          <Tabs defaultValue={TABS[0].id} onValueChange={onTabChange} className="w-full flex flex-col h-full">
            <TabsList className="grid w-full grid-cols-2 bg-[#131720] rounded-lg h-auto">
              {TABS.map((tab) => (
                <TabsTrigger
                  key={tab.id}
                  value={tab.id}
                  className={clsx('text-[#586272] rounded-md py-[4px] text-[13px] data-[state=active]:bg-[#00BBFF] data-[state=active]:text-white data-[state=active]:shadow-sm')}
                >
                  {tab.label}
                </TabsTrigger>
              ))}
            </TabsList>
            <TabsContent value={TABS[0].id} className="flex-1 overflow-hidden mt-1">
              <HistoryTab visible={activeTab === TABS[0].id} operate="1" />
            </TabsContent>
            <TabsContent value={TABS[1].id} className="flex-1 overflow-hidden mt-1">
              <StatisticTab visible={activeTab === TABS[1].id} operate="2" />
            </TabsContent>
          </Tabs>
        </div>
      </DrawerContent>
    </Drawer>
  );
});

export default HistoryStatistic;